import * as React from 'react';
import history from '@src/utils/history';
const Back = () => (
  <div className="go-back-btn" onClick={() => history.goBack()}>
    <i className="fas fa-long-arrow-alt-left" />
    前の画面に戻る
  </div>
);
export default Back;


// WEBPACK FOOTER //
// ./src/components/common/Back.tsx